<template>
  <div @click="$emit('click')" class="click-wrapper" :class="{ disabled }">
    <component
      :is="hasTooltip ? 'CustomTooltip' : 'div'"
      v-bind="hasTooltip ? { title: 'Más Información', placement: 'bottom' } : {}"
    >
      <template v-if="hasTooltip" #content>
        <slot name="tooltip" />
      </template>

      <Card
        class="customCard primaryFont"
        :class="{ 'disabled-card': disabled }"
        :style="{
          borderLeft: `6px solid ${borderColor}`,
          backgroundColor: isSelected ? '#EEEEEE' : '#FFFFFF',
        }"
      >
        <template #title>
          <div class="flex w-full justify-content-between align-items-center">
            <slot name="title" />
            <StateChip :stateColor="statusColors" :stateText="status" />
          </div>
        </template>
        <template #content>
          <div class="flex w-full justify-content-between align-items-center">
            <slot name="content" />
            <StateChip
              v-if="shouldShowCalabozo"
              :stateColor="getCalabozoColors(props.statusCalabozo)"
              :stateText="statusCalabozo"
            />
          </div>
        </template>
      </Card>
    </component>
  </div>
</template>

<script setup>
import { getCurrentInstance, computed } from "vue";
import StateChip from "@/pages/sumario/componentsViewActuacion/StateChip.vue";

const instance = getCurrentInstance();
const slots = instance?.slots || {};
const hasTooltip = computed(() => !!slots.tooltip);

const props = defineProps({
  color: { type: String, default: "" },
  status: { type: String, default: "" },
  statusCalabozo: { type: String, default: "" },
  isSelected: { type: Boolean, default: false },
  isPreview: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const calabozoStatusFormat = computed(() =>
  (props.statusCalabozo ?? "").toString().toLowerCase().trim()
);

const statusToColorMap = {
  denunciado: "red",
  damnificado: "red",
  detenido: "red",
  secuestrado: "orange",
  acusado: "orange",
  denunciante: "orange",
  "denunciante y damnificado": "green",
  recuperado: "green",
};

const statusCalabozoToColorMap = {
  "en calabozo": "red",
  pendiente: "orange",
  liberado: "green",
};

const shouldShowCalabozo = computed(
  () => props.status?.toLowerCase().includes("detenido") && calabozoStatusFormat.value
);

const getColorFromStatus = (status) => {
  if (!status) return "gray";

  const lowerStatus = status.toLowerCase().trim();

  if (statusToColorMap[lowerStatus]) {
    return statusToColorMap[lowerStatus];
  }

  if (lowerStatus.includes("denunciante") && lowerStatus.includes("damnificado")) {
    return "green";
  }

  for (const key in statusToColorMap) {
    if (lowerStatus.includes(key)) {
      return statusToColorMap[key];
    }
  }

  return "gray";
};

const getCalabozoColors = (statusCalabozo) => {
  if (!statusCalabozo)
    return statusChipColors.gray || { fontColor: "#949494", backgroundColor: "#DFDFDF" };

  const colorKey = statusCalabozoToColorMap[statusCalabozo.toLowerCase().trim()];
  return (
    statusChipColors[colorKey] ||
    statusChipColors.gray || { fontColor: "#949494", backgroundColor: "#DFDFDF" }
  );
};

const statusBorderColors = {
  red: "#D20F39",
  orange: "#D97706",
  green: "#1A8245",
};

const statusChipColors = {
  red: { fontColor: "#D20F39", backgroundColor: "#FFD2CA" },
  orange: { fontColor: "#D97706", backgroundColor: "#FFFBEB" },
  green: { fontColor: "#1A8245", backgroundColor: "#DAF8E6" },
};

const borderColor = computed(() => {
  if (props.isPreview) return "#0B5195";
  const effectiveColor = props.color || getColorFromStatus(props.status);
  return statusBorderColors[effectiveColor.toLowerCase()] || "#000000";
});

const statusColors = computed(() => {
  const effectiveColor = props.color || getColorFromStatus(props.status);
  const colors = statusChipColors[effectiveColor.toLowerCase()] || {
    fontColor: "#949494",
    backgroundColor: "#DFDFDF",
  };

  return colors;
});
</script>
<style scoped>
.customCard {
  border-radius: 8px;
  box-shadow: 0px 4px 4px 0px #00000040;
  min-height: 120px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.customCard {
  width: 100%;
}

.disabled-card {
  opacity: 0.6;
  background-color: #f5f5f5 !important;
  cursor: not-allowed;
}

.disabled-text {
  color: #999999 !important;
}

.disabled {
  cursor: not-allowed;
  pointer-events: none;
}

.click-wrapper {
  cursor: pointer;
  min-height: 120px;
}

/* Make the clickable wrapper fill its container width */
.click-wrapper {
  width: 100%;
}

.preview-mode {
  cursor: default;
}

>>> .p-card .p-card-body {
  width: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0.5rem 1rem;
}

>>> .cardTitle[data-v-b035efb2] {
  font-weight: 700;
  font-style: bold;
  font-size: 20px;
  color: black;
  /* margin-top: 15px; */
}

>>> .p-card .p-card-content {
  padding: 0.25rem 0;
}

/* >>> .status-label[data-v-1aabf0d6] {
  margin-top: 15px;
} */
</style>
